import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import { Box, PagePanel, ImagePanel, Heading1, Button, Text } from 'edenred-ui';

import { getUserRoles } from '@epi-selectors/login';
import RequestContactImg from '@epi-assets/images/RequestContact.jpg';
import { useEmailConfirmation } from '@epi-shared/hooks/useEmailConfirmation';
import paymentImg from '@epi-assets/images/Edenred-EMP-banner-payment.jpg';

import { UnstyledLink } from './RequestContact.styles';

export const RequestContact = () => {
  useEmailConfirmation();
  const { t } = useTranslation();
  const theme = useTheme();
  const loginData: string[] = useSelector(getUserRoles);
  const isClient: boolean =
    loginData.includes('voucherManager') && loginData.length === 1;

  return isClient ? (
    <PagePanel>
      <Box bgcolor={theme.primaryBackColorLight10}>
        <ImagePanel imageSrc={paymentImg} reverse>
          <Box p={5}>
            <Heading1>{t('paper_vouchers.request_contact.title')}</Heading1>
            <Box mt={4}>
              <Text>
                <Trans i18nKey={t('paper_vouchers.request_contact.text')} />
              </Text>
            </Box>
            <Box mt={6} display="flex" gap={3}>
              <Button id="paper-vouchers-btn-anchor" minWidth={200}>
                <UnstyledLink
                  target="_blank"
                  href={t('paper_vouchers.request_contact.link')}
                >
                  {t('paper_vouchers.request_contact.button')}
                </UnstyledLink>
              </Button>
              <Button id="paper-vouchers-btn-anchor-two" minWidth={200}>
                <UnstyledLink
                  target="_blank"
                  href={t('paper_vouchers.request_contact.linkTwo')}
                >
                  {t('paper_vouchers.request_contact.buttonTwo')}
                </UnstyledLink>
              </Button>
            </Box>
          </Box>
        </ImagePanel>
      </Box>
    </PagePanel>
  ) : (
    <Box mt={5} />
  );
};
